import { Component, Inject, OnInit } from '@angular/core';
import { Shipment } from '../../../models/shipment';
import { Quote } from '../../../models/quote';
import { ShipmentValidatorService } from '../../shared/services/shipment-validator.service';
import { Violation } from '../../../models/violation';
import { Observable } from 'rxjs';
import { AppState } from '../../../store';
import { Store } from '@ngrx/store';
import { activeShipmentActions } from '../../../store/journal/journal.state';
import { map } from 'rxjs/operators';
import { SubmissionService } from '../../shared/services/submission.service';
import { ServerExceptionEnum } from '../../../enum/server-exception.enum';
import { ServerMessage } from '../../../models/server-message';
import { shipmentEditorLoadRequest, shipmentEditorSetValidationMode } from '../../../store/shipment-editor/shipment-editor.actions';
import { ShipmentService } from '../../../data/shipment.service';
import { SubmitResult } from '../../../models/submit-result';
import { DocumentService } from '../../shared/services/document.service';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatButton } from '@angular/material/button';
import { ServerMessageComponent } from '../../shared/server-message/server-message.component';
import { IconComponent } from '../../shared/icon/icon.component';
import { QuoteCardComponent } from '../quote-card/quote-card.component';
import { AsyncPipe } from '@angular/common';
import { Router } from '@angular/router';
import { ValidationMode } from '../../../enum/validation-mode.enum';

@Component({
    selector: 'app-shipment-submit',
    templateUrl: './shipment-submit.component.html',
    styleUrls: ['./shipment-submit.component.scss'],
    imports: [QuoteCardComponent, IconComponent, ServerMessageComponent, MatButton, AsyncPipe]
})
export class ShipmentSubmitComponent implements OnInit {

    readonly quoteNotFoundException = ServerExceptionEnum.QUOTE_NOT_FOUND_EXCEPTION;

    public shipment: Shipment;
    public quote: Quote;
    public violations: Violation[];
    public busy$: Observable<boolean>;
    public errors: ServerMessage[] = [];
    public exception: string = null;
    public result: SubmitResult = null;

    constructor(@Inject(MAT_DIALOG_DATA) data: { shipment: Shipment, quote: Quote },
                private dialogRef: MatDialogRef<ShipmentSubmitComponent>, private validator: ShipmentValidatorService,
                private store: Store<AppState>, private shipmentSubmitService: SubmissionService,
                private shipmentService: ShipmentService, private documentService: DocumentService,
                private breakpointObserver: BreakpointObserver, private router: Router) {
        this.shipment = data.shipment;
        this.quote = data.quote;
        this.busy$ = this.store.select(activeShipmentActions(this.shipment.id)).pipe(
            map((a) => a.length > 0)
        );
    }

    public displayCard$: Observable<boolean> = this.breakpointObserver.observe(Breakpoints.XSmall).pipe(
        map((state) => !state.matches)
    );

    ngOnInit(): void {
        this.store.dispatch(shipmentEditorSetValidationMode({ mode: ValidationMode.SUBMIT }));
        this.violations = this.validator.validateEditorShipment(this.shipment, ValidationMode.SUBMIT);
    }

    ship(): void {
        this.shipmentSubmitService.submitQuote(this.shipment.id, this.quote.id).subscribe(
            (submission) => {
                if (submission.result === ServerExceptionEnum.SUCCESS) {
                    this.result = submission;
                    this.store.dispatch(shipmentEditorLoadRequest({ id: this.shipment.id }));
                    this.router.navigate(['shipment', this.shipment.id, 'view']);
                } else {
                    this.exception = submission.result;
                    this.errors = submission.messages;
                }
            }
        );
    }

    close(): void {
        this.dialogRef.close();
    }

    printWaybills(): void {
        this.documentService.openShipmentWaybills([ this.shipment.id ]);
        this.close();
    }
}
